"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Attention = function Attention(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 33 32'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-545.000000, -396.000000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(62.000000, 357.000000)'
  }, /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(483.500000, 39.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M16.4324324,0 C7.59480822,0 0.432432432,7.15370356 0.432432432,15.9806271 C0.432432432,24.8075507 7.59480822,32 16.4324324,32 C25.2700566,32 32.4324324,24.8036866 32.4324324,16.0193729 C32.4324324,7.19244928 25.2700566,0 16.4324324,0 Z M16.4324324,30.4507454 C8.4750678,30.4507454 1.98356514,23.9671027 1.98356514,16.0193729 C1.98356514,8.07164304 8.4750678,1.54539046 16.4324324,1.54539046 C24.3897971,1.54539046 30.8812997,8.02903318 30.8812997,16.0193729 C30.8812997,24.0097125 24.3897971,30.4507454 16.4324324,30.4507454 Z M17.227369,22.5456254 C17.227369,23.0065534 16.8512053,23.3822093 16.3897709,23.3822093 C15.9282842,23.3822093 15.5521729,23.0065011 15.5521729,22.5456254 C15.5521729,22.0846975 15.9283365,21.7090415 16.3897709,21.7090415 C16.8512053,21.7090415 17.227369,22.0847497 17.227369,22.5456254 Z M15.5948344,18.4439571 L15.5948344,9.03219237 C15.5948344,8.61387431 15.9283365,8.28077596 16.3471617,8.28077596 C16.7659869,8.28077596 17.099489,8.61387431 17.099489,9.03219237 L17.099489,18.4439571 C17.099489,18.8622751 16.7659869,19.1953735 16.3471617,19.1953735 C15.9283365,19.2418475 15.5948344,18.8622751 15.5948344,18.4439571 Z'
  })))))));
};
/* eslint-enable */
var _default = Attention;
exports["default"] = _default;